<template>
    <div
        :class="[
            'HeaderCards',
            highlighted && 'HeaderCards--highlighted'
        ]"
    >
        <div class="HeaderCards__header">
            {{ header }}
        </div>
        <div class="HeaderCards__number">
            <slot><h2>{{ number }}</h2></slot>
        </div>
    </div>
</template>
<script>
export default {
    name: 'HeaderCards',
    props: {
        header: {
            type: String,
            required: true
        },
        number: {
            type: [String, Number],
            default: ''
        },
        highlighted: {
            type: Boolean,
            default: false,
        }
    }
};
</script>
<style lang="scss">
    .HeaderCards {
        padding: 1rem 0.5rem 0.5rem 0.5rem;
        &--highlighted {
            border-radius: 4px;
            border: 1px solid $secondary-purple;
            background: $secondary-purple-50
        }
        &__header {
            color: $text-grey;
            font-size: .75rem;
        }
    }
</style>
